import { render, staticRenderFns } from "./callbackTask.vue?vue&type=template&id=622751ac&scoped=true&"
import script from "./callbackTask.vue?vue&type=script&lang=js&"
export * from "./callbackTask.vue?vue&type=script&lang=js&"
import style0 from "./callbackTask.vue?vue&type=style&index=0&id=622751ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622751ac",
  null
  
)

export default component.exports